import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-25f518f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chat-dialog-container"
}
const _hoisted_2 = { class: "chat-dialog" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"flex-end","padding":"10px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Set Prompt Template", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-height":"500px","overflow-y":"auto","margin":"10px"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"margin":"15px","text-align":"left","word-break":"normal"},
    id: "answer"
  })
], -1))

import { useAuth0 } from '@auth0/auth0-vue';
import axios from 'axios';
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'SetTemplateDialog',
  setup(__props) {

const { user } = useAuth0()

const store = useStore()

const showDialog = computed({
    get: () => store.getters.showSetTemplateDialog,
    set: (value) => store.commit('SET_SHOW_SET_TEMPLATE_DIALOG', value)
})

const text = ref("")

const loading = ref(false)


const send = async () => {
    const answer = document.getElementById("answer")

    loading.value = true
    answer!.innerHTML = "Loading..."
    answer!.classList.add("blink_me")
    let response: any = null

    try {
        response = await axios.post(`${process.env.VUE_APP_BACKEND_URI}/template`, { template: text.value, email: user.value.email })

        loading.value = false
        answer!.classList.remove("blink_me")
        answer!.innerHTML = "The template was updated."

        setTimeout(() => {
            answer!.innerHTML = ""
        }, 500);


    } catch (error) {
        answer!.classList.remove("blink_me")
        loading.value = false
        answer!.innerHTML = "Error..."
    }



}

watch(showDialog, async (value) => {
    if (value === true) {
        try {
            const response = await axios.get(`${process.env.VUE_APP_BACKEND_URI}/template?email=${user.value.email}`)
            text.value = response.data.template

        } catch (error) {
            console.log(error)
        }
    }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (showDialog.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "chat-background",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = false))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _imports_0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = false)),
                  style: {"cursor":"pointer","width":"38px"}
                })
              ]),
              _hoisted_4,
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((text).value = $event))
                }, null, 512), [
                  [_vModelText, text.value]
                ])
              ]),
              _createElementVNode("button", {
                class: "send-button-chat",
                onClick: send
              }, "Send"),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})